<template lang="pug">
.container.grid-lg
  .text-bold.my-2.py-2 Relatórios disponíveis para Produtividade
  .columns
    .column.col-4.col-lg-6.col-md-12.mb-2.pb-2(v-for='item in items')
      row(v-bind='item', v-acl:allowed='item.acl')
</template>

<script>
import Row from '../components/ReportRow'

export default {
  components: { Row },
  computed: {
    items() {
      return [
        {
          icon: 'fa fa-line-chart',
          title: 'Média geral',
          subtitle: 'Resumo da evolução mensal da média geral dos fiscais',
          to: { name: 'app.indicadores.produtividade.mediaGeral' },
          acl: ['admin', 'indicadores', 'produtividade', 'gerais'],
        },
        {
          icon: 'fa fa-user',
          title: 'Pontuação por fiscal',
          subtitle: 'Resumo da evolução mensal da média de um fiscal',
          to: { name: 'app.indicadores.produtividade.pontuacaoFiscais' },
          acl: ['admin', 'indicadores', 'produtividade', 'resumos'],
        },
      ]
    },
  },
}
</script>
